export default __webpack_public_path__ + "static/media/areatoraise-one.b17d3b73.jpg";